<template>
    <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
      <div class="delete-modal">
        <div class="flex justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 47 47" fill="none">
                <g clip-path="url(#clip0_2930_39984)">
                <path d="M46.3001 23.1501C46.3001 35.9356 35.9356 46.3001 23.1501 46.3001C10.3646 46.3001 0 35.9356 0 23.1501C0 10.3646 10.3646 0 23.1501 0C35.9356 0 46.3001 10.3646 46.3001 23.1501Z" fill="#09B78A" fill-opacity="0.1"/>
                <path d="M20.2775 26.2659L16.3785 22.3993L15 23.7663L20.2775 29L31 18.367L29.6215 17L20.2775 26.2659Z" fill="#09B78A"/>
                </g>
                <defs>
                <clipPath id="clip0_2930_39984">
                <rect width="46.3" height="46.3" fill="white"/>
                </clipPath>
                </defs>
                </svg>
        </div>
  
        <div class="my-6">
            <div class="text-primary-green">Your booking is confirmed.</div>
            <p>Have You received this package?</p>
            <div class="px-12 mt-3">
              <div class="flex justify-between">
                <label class="radio-label" for="yes">
                  <input
                    type="radio"
                    name="shippingtype"
                    id="yes"
                    value="yes"
                    v-model="receivedPackage"
                  />
                  Yes
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="no">
                  <input
                    type="radio"
                    id="pickup"
                    name="shippingtype"
                    value="no"
                    v-model="receivedPackage"
                  />
                  No
                  <span></span>
                </label>
              </div>
            </div>
        </div>
          <div>
            <base-button @click="closeModal()" text="Submit" />
          </div>
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: {
      showModal: {
        type: Boolean,
        required: true,
        default: false,
      },
      endRoute: {type: String}
    },
    data(){
      return {
        showDeclineReasonModal: false,
        receivedPackage : "no"
      }
    },

    methods: {
      closeModal() {
        this.showDeclineReasonModal = true
        this.createShippingId();
        this.$emit("close-modal");
        this.$router.push('/operations/booking')
        this.$store.dispatch("resetState");
      },

      async createShippingId() {
        let status = 'pending'
        if(this.receivedPackage == 'yes'){
          status = 'received'
        }
        const payload = {
          payload: {
            id : this.$store.state.bookingModule.shippingId,
            deliveryStatus: status,
            currentStep: 6,
          },
        };

        await this.$_createShippingId(payload)
          .then((response) => {
            this.$store.dispatch(
              "saveShippingId",
              response.data.data.shipping.id
            );

            this.$store.dispatch("saveBookingInformation", {
              property: "shippingInformation",
              value: response.data.data.shipping,
            });
          })
          .catch((e) => {
            this.handleError(e);
          });
        this.isLoading = false;
      },
    }
  };
  </script>
  
  <style scoped>
  .delete-modal {
    text-align: center;
  }
  </style>
  